import React from "react";
import Image from "@herb/components/Image";
import {
  trackTransferToShop,
  trackSelectPromotion
} from "../../../utils/analytics";
import { getOutboundLinkRel } from "@herb/utils";
import "./index.css";
const DealCard = ({ deal }) => {
  const { title } = deal;
  const content = deal?.contentDeals?.contentDeals;
  const customTitle = content?.customTitle || content?.product?.title;
  const {
    product,
    dealOffer,
    badgeText,
    badgeColor,
    badgeBackgroundColor,
    dealLink,
    ctaColor,
    ctaBackgroundColor,
    ctaLabel,
    dealOfferColor
  } = content;

  const rel = getOutboundLinkRel({ brand: product?.brand_name || title });

  // Get image from new schema
  let imageUrl = "";
  if (product?.contentProducts?.productImages?.length > 0) {
    imageUrl = product.contentProducts.productImages[0].sourceUrl;
  }

  const brandName = product?.brand_name || title;
  const productTitle = customTitle || "";

  return (
    <a
      className="dealCardMain"
      href={dealLink || "#"}
      target="_blank"
      rel={rel}
      onClick={() => {
        if (typeof trackSelectPromotion === "function") {
          trackSelectPromotion({
            promotionName: title,
            dealType: "standard_deal",
            brand: brandName,
            category: product?.contentProducts?.productCategory?.name || ""
          });
        }
        if (typeof trackTransferToShop === "function") {
          trackTransferToShop({
            affiliateUrl: "",
            contentType: "deals_page",
            surfaceType: "deal_card",
            productTitle: title,
            category: product?.contentProducts?.productCategory?.name || "",
            brand: brandName
          });
        }
      }}
    >
      <div className="dealsCardImageWrapper">
        {badgeText && (
          <span
            className="dealsCardBadge"
            style={{ backgroundColor: badgeBackgroundColor, color: badgeColor }}
          >
            {badgeText}
          </span>
        )}
        <Image className="dealsCardImage" src={imageUrl} width={500} />
      </div>
      <div
        className="dealsCardClaimBar"
        style={{
          backgroundColor: ctaBackgroundColor,
          color: ctaColor
        }}
      >
        {ctaLabel || "Claim Deal"}
      </div>
      <div className="dealTitleAndProductTitle">
        <h3 className="dealsCardBrand">{brandName}</h3>
        {customTitle && <p className="dealsCardProductTitle">{customTitle}</p>}
        {dealOffer && (
          <p className="dealsCardOffer" style={{ color: dealOfferColor }}>
            {dealOffer}
          </p>
        )}
      </div>
    </a>
  );
};

export default DealCard;
